import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { useNews } from "../queries/useNews"


const TestPage = () => {

    const {data: news, isLoading, error} = useNews()
    console.log({news});
  return (
    <>
    {news?.data.map(item => {
        const htmlBody = documentToHtmlString(item.body)
        console.log({body: item.body, htmlBody});
        return <>htmlBody</>
    })}
      
    </>
  )
}

export default TestPage
